import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "language-selector cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "selected-language-code"
}

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import useTextareaComponent, {} from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import {computed, ref, watch} from "vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import LanguagePopover from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/LanguagePopover.vue";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "TranslateButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, site} = useTextareaComponent();
let isTranslateEnabled = computed({
    get() {
        return ClientUserdataStore.isTranslateEnabled(client.value.username);
    },
    set(value: boolean) {
        setTimeout(() => {
            ClientUserdataStore.SET_TRANSLATE_ENABLED({username: client.value.username, value});
        }, 10);
    }
});

let isAvailable = !!isTranslateEnabled;
let popoverModel = ref(false);

let languageDescr = computed(() => {
    let result = client.value.languageIsoCode;
    if (result) {
        let language = OperatorAccountStore.data.value.languages.find(language => language.id == result);
        if (language) {
            result = language.descr;
        }
    }
    return result;
});

async function selectLanguage(languageId: string) {
    popoverModel.value = false;
    let p: OperatorApplicationApi.OperatorBuddyListUpdateClientInfoOpenApiModel = {
        username: client.value.username,
        languageIsoCode: languageId
    };
    client.value.languageIsoCode = languageId;
    await (new OperatorApiRequest({
        url: "/buddyList/updateClientInfo",
        p,
        silent: true
    })).send()
}

async function toggleTranslate() {
    if (isTranslateEnabled.value || site.value.isCopilotAvailableByTarif) {
        isTranslateEnabled.value = !isTranslateEnabled.value;
        if (isTranslateEnabled.value) {
            if (!client.value.languageIsoCode) {
                let p: OperatorApplicationApi.OperatorCopilotDetectClientLanguageOpenApiModel = {
                    username: client.value.username
                };
                let result = await (new OperatorApiRequest({
                    url: "/copilot/detectClientLanguage",
                    p,
                    silent: true
                })).send();
                if (result.showMessageOnError()) {
                    isTranslateEnabled.value = false;
                }
            }
        }
    } else {
        OpenApiResult.showMessage(
            __("На этом проекте не оплачена возможность использования искусственного интеллекта"),
            "error"
        );
    }
}

watch(isTranslateEnabled, async value => {
    if (value) {
        if (!client.value.languageIsoCode) {
            let p: OperatorApplicationApi.OperatorCopilotDetectClientLanguageOpenApiModel = {
                username: client.value.username
            };
            let result = await (new OperatorApiRequest({
                url: "/copilot/detectClientLanguage",
                p,
                silent: true
            })).send();
            if (result.showMessageOnError()) {
                isTranslateEnabled.value = false;
            }
        }
    }
})

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_unref(isAvailable))
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass({
            wrapper: true,
            enabled: _unref(isTranslateEnabled)
        })
      }, [
        _createVNode(OperatorApplicationDialogTextareaButton, {
          icon: "language",
          tooltip: _unref(__)('Перевод'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleTranslate()))
        }, {
          icon: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "icon",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "m12.87 15.07l-2.54-2.51l.03-.03A17.5 17.5 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5l3.11 3.11zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2zm-2.62 7l1.62-4.33L19.12 17z"
              })
            ], -1)
          ]))]),
          _: 1
        }, 8, ["tooltip"]),
        (_unref(isTranslateEnabled))
          ? (_openBlock(), _createBlock(LanguagePopover, {
              key: 0,
              modelValue: _unref(popoverModel),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(popoverModel) ? (popoverModel).value = $event : popoverModel = $event)),
              languages: _unref(OperatorAccountStore).data.value.languages,
              onSelect: selectLanguage
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, [
                  (_unref(client).languageIsoCode)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_unref(client).languageIsoCode), 1)
                      ])), [
                        [_directive_my_tooltip, _unref(languageDescr)]
                      ])
                    : (_openBlock(), _createBlock(MyLoader, {
                        key: 1,
                        class: "icon loader"
                      }))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "languages"]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})